// Central catalog of test ids used across the app.
export const HOME = {
  emergentLink: "emergent-link",
};

export const TID = {
  navHome: "nav-home",
  navProducts: "nav-products",
  navGallery: "nav-gallery",
  navTestimonials: "nav-testimonials",
  navOrder: "nav-order",
  ctaOrderHero: "hero-cta-order",
  ctaCatalogHero: "hero-cta-catalog",
  nancyToggle: "nancy-toggle",
  productCard: "product-card",
  productOrderBtn: "product-order-btn",
  galleryItem: "gallery-item",
  orderForm: "order-form",
  orderName: "order-name",
  orderPhone: "order-phone",
  orderEmail: "order-email",
  orderAddress: "order-address",
  orderMessage: "order-message",
  orderSubmit: "order-form-submit-button",
  orderAddItem: "order-add-item",
  orderItemRow: "order-item-row",
  orderItemRemove: "order-item-remove",
  socialFacebook: "social-facebook",
  socialInstagram: "social-instagram",
};
